"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var MedalBronze_1 = __importDefault(require("./MedalBronze"));
var MedalGold_1 = __importDefault(require("./MedalGold"));
var MedalSilver_1 = __importDefault(require("./MedalSilver"));
var Medal = function (_a) {
    var rank = _a.rank, props = __rest(_a, ["rank"]);
    switch (rank) {
        case 1:
            return (0, jsx_runtime_1.jsx)(MedalGold_1.default, __assign({}, props));
        case 2:
            return (0, jsx_runtime_1.jsx)(MedalSilver_1.default, __assign({}, props));
        default:
            return (0, jsx_runtime_1.jsx)(MedalBronze_1.default, __assign({}, props));
    }
};
exports.default = Medal;
